import { ProviderFundsPage } from '../providerFunds/ProviderFundsPage';
import { CORPORATE_FUNDS_CONFIG } from '../providerFunds/config';

export function CorporateFundsPage() {
  return <ProviderFundsPage config={CORPORATE_FUNDS_CONFIG} />;
}
